export default "__VITE_ASSET__Ci9H1du4__"